module.exports = __webpack_public_path__ + "static/media/29BDOS2.e237a5e6.jpg";